import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { DeleteAgentResponseSchema } from "../response/DeleteAgentResponse";

interface DeleteAgentData {
    id: string;
}

export const useDeleteAgent = () => {
    return useMutation({
        mutationKey: ['agents', 'delete'],
        mutationFn: async (formData: DeleteAgentData) => privateApi.delete(`/v3/agent/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeleteAgentResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid agent data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid agent data format");
            } else {
                console.error(`Failed to delete agent`, error);
                throw error;
            }
        }
    })
}